import { Input, Select, Button, message, Form } from 'antd';
import React, { useContext, useState, useEffect } from 'react';
import { myAxios } from 'utils/request';
import styled from 'styled-components';
import { useHistory } from 'react-router';

import { useDict } from '../../context';
import { getStorage } from 'utils/storage';

const FormItem = Form.Item;

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 13 },
};
const tailLayout = {
  wrapperCol: { offset: 5, span: 10 },
};

const FormItemStyled = styled(FormItem)`
  margin-bottom: 16px;
  padding-left: 80px !important;
  .ant-select {
    width: 100%;
  }
`;
interface IProps {
  detail?: any;
  mutate: any;
}

const Regs = {
  Facebook: [
    /(^\d{15}$)|(^\d{16}$)/,
    getStorage('locale') === 'en'
      ? '必须是15或16位数字'
      : 'IT MUST BE 15 OR 16 DIGITS',
  ],
  'Google Analytics': [
    /(^UA-\d{8}-\d$)|(^UA-\d{9}-\d$)/,
    getStorage('locale') === 'en'
      ? '请检查ID格式'
      : 'PLEASE CHECK THAT THE ID FORMAT',
  ],
};

const defaultIdRules = [
  {
    required: true,
    message:
      getStorage('locale') === 'en' ? '请输入pixelId' : 'Please enter pixelId!',
  },
];

export const TrackFrom = (props: IProps) => {
  const { collectionas, platforms } = useDict();
  const [inputValue, setInput] = useState<string>('1234');
  const [platform, setPlatform] = useState<any>('');
  const [idRules, setIdRules] = useState<any>(defaultIdRules);
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (Object.keys(Regs).indexOf(platform) >= 0) {
      let newRules = [
        ...defaultIdRules,
        { pattern: Regs[platform][0], message: Regs[platform][1] },
      ];
      setIdRules(newRules);
    } else {
      setIdRules(defaultIdRules);
    }
  }, [platform]);
  return (
    <Form
      {...layout}
      onFinish={values => {
        let params = values;
        params.collectionTitle = collectionas.find(
          item => +item.collectionId === +values.collection,
        ).title;
        setLoading(true);
        myAxios
          .post('/trackify/pixel/save', params)
          .then(({ data }) => {
            const { success } = data;
            if (success) {
              message.success(
                getStorage('locale') === 'en' ? '添加成功' : 'create success',
              );
            } else {
              message.error(data.message);
              return false;
            }
            history.push('/track-list');
            props.mutate();
          })
          .finally(() => {
            setLoading(false);
          });
      }}
      onFinishFailed={errorInfo => {
        console.log('Failed:', errorInfo);
      }}
      initialValues={{
        platform: props.detail?.platform,
        pixelId: props.detail?.pixelId,
        collection: props.detail?.collection || undefined,
        id: props.detail?.id,
      }}
    >
      <FormItem name="id" style={{ display: 'none' }}>
        <Input />
      </FormItem>
      <FormItemStyled
        name="platform"
        label={getStorage('locale') === 'en' ? '平台名称' : 'platform'}
        rules={[
          {
            required: true,
            message:
              getStorage('locale') === 'en'
                ? '请选择平台名称'
                : 'Please select platform!',
          },
        ]}
      >
        <Select
          placeholder={
            getStorage('locale') === 'en' ? '选择平台' : 'choose platform'
          }
          onChange={key => {
            setPlatform(key);
          }}
        >
          {platforms.map((item, i) => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </FormItemStyled>
      <FormItemStyled name="pixelId" label="ID" rules={idRules}>
        <Input
          value={inputValue}
          onChange={e => {
            console.log('e', e.target.value.replace(/\s/g, ''));

            setInput(e.target.value.replace(/\s/g, ''));
          }}
          placeholder={
            getStorage('locale') === 'en'
              ? '请输入pixelId'
              : 'Please enter pixelId!'
          }
        />
      </FormItemStyled>
      <FormItemStyled
        name="collection"
        label={getStorage('locale') === 'en' ? '产品系列' : 'collection'}
        rules={[
          {
            required: true,
            message:
              getStorage('locale') === 'en'
                ? '请选择产品系列'
                : 'Please enter collection!',
          },
        ]}
      >
        <Select
          placeholder={
            getStorage('locale') === 'en' ? '选择产品系列' : 'choose collection'
          }
        >
          {collectionas.map(item => (
            <Select.Option value={item.collectionId} key={item.collectionId}>
              {item.title}
            </Select.Option>
          ))}
        </Select>
      </FormItemStyled>
      <FormItemStyled {...tailLayout}>
        <Button type="primary" htmlType="submit" loading={loading}>
          {getStorage('locale') === 'en' ? '提交' : 'submit'}
        </Button>
      </FormItemStyled>
    </Form>
  );
};
